import React from 'react'
import { useNavigate } from "react-router-dom"
import {
    Box,
    Stack,
} from '@mui/material'

import { FadBox } from "../../utils/fade-box/fadeBox.js"
import * as Assets from '../../utils/assets.js'

const Main = () => {
    const navigate = useNavigate()

    return (
        <Box textAlign={"center"}>
            <Stack
                data-aos="fade-up"
                direction={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                flexWrap={"wrap"}
            >
                <Box
                    sx={{
                        width: { xs: "100%", lg: "49%" },
                        my: { xs: 2 }
                    }}
                    onClick={() => navigate(`/weddings`)}>
                    <FadBox
                        src={Assets.weddings[0]}
                        alt={"Widdings"}
                        text={"Weddings"} />
                </Box>
                <Box
                    sx={{
                        width: { xs: "100%", lg: "49%" },
                        my: { xs: 2 }
                    }}
                    onClick={() => navigate(`/engagements`)}>
                    <FadBox
                        src={Assets.engagements[0]}
                        alt={"Engagements"}
                        text={"Engagements"} />
                </Box>
                <Box
                    sx={{
                        width: { xs: "100%", lg: "49%" },
                        my: { xs: 2 }
                    }}
                    onClick={() => navigate(`/kids`)}>
                    <FadBox
                        src={Assets.kids[0]}
                        alt={"Kids"}
                        text={"Kids"} />
                </Box>
            </Stack >
        </Box >
    )
}

export default Main